export enum Role {
  SupportAdmin = 'SupportAdmin',
  WageDataAdmin = 'WageDataAdmin',
  Admin = 'Admin',
  FullAdmin = 'FullAdmin',
  BusinessManager = 'BusinessManager',
  LimitedAdmin = 'LimitedAdmin',
}
